import HelpIcon from '@mui/icons-material/Help';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { formatDate } from '../../../../utilityFunctions';
export const BkgPrintMessage = (props) => {
    const { msg } = props
    return (
        <div className="agentDialogWrap">
            <div className="agentSvg">
                <HelpIcon sx={{ width: '36px', height: '36px', color: '#0086FF' }} />
            </div>
            <div className="agentMessage">
                {msg}
            </div>
        </div>
    )
}


export const SuccessfulMessage = (props) => {
    const { message } = props
    return (
        <div className="successfulDialogWrap">
            <div className="icons">
                <CheckCircleIcon sx={{ width: '38px', height: '38px', color: '#3C763C' }} />
                <div className='successfulHeader'>Success !</div>
            </div>
            <div className="message">
                {message}
            </div>
        </div>)
}


export const POSPaymentMessage = (props) => {
    const { message } = props
    return (
        <div className="successfulDialogWrap">
            {/* <div className="icons">
                <CheckCircleIcon sx={{ width: '38px', height: '38px', color: '#3C763C' }} />
                <div className='successfulHeader'>Success !</div>
            </div> */}
            <div className="message">
                {message}
            </div>
        </div>)
}
export const ticketColumnDef = [
    { headerName: 'Trip\nCode', field: '', headerSx: { textAlign: 'left', width: "98px" }, },
    { headerName: 'Depot\nName', field: '', headerSx: { textAlign: 'left', width: "148px" }, },
    { headerName: 'Via\nPlace', field: '', headerSx: { textAlign: 'left', width: "300px" }, },
    { headerName: 'Distance\n(Kms)', field: '', headerSx: { textAlign: 'left', width: "77px" }, },
    { headerName: 'Departure\nTime', field: '', headerSx: { textAlign: 'left', width: "65px" }, },
    { headerName: 'Arrival\nTime', field: '', headerSx: { textAlign: 'left', width: "70px" }, },
    { headerName: 'Adult Fare\n(Incl.Levies)', field: '', headerSx: { textAlign: 'right', width: "160px" }, },
    { headerName: 'Child\nFare', field: '', headerSx: { textAlign: 'right', width: "70px" }, },
    { headerName: 'Type', field: '', headerSx: { textAlign: 'left', width: "54px" }, },
    { headerName: 'Seats', field: '', headerSx: { textAlign: 'left', width: "51px" }, },
    { headerName: 'Trip Sheet\nCut-Off Time', field: '', headerSx: { textAlign: 'left', width: "95px" }, },
    { headerName: 'Action', field: '', headerSx: { textAlign: 'left', width: "81px" }, },
]

export const ticketColumnDefAdmin = [
    { headerName: 'Trip\nCode', field: '', headerSx: { textAlign: 'left', width: "98px" }, },
    { headerName: 'Depot\nName', field: '', headerSx: { textAlign: 'left', minWidth: "148px" }, },
    { headerName: 'Via\nPlace', field: '', headerSx: { textAlign: 'left', minWidth: "180px" }, },
    { headerName: 'Distance\n(Kms)', field: '', headerSx: { textAlign: 'left', width: "77px" }, },
    { headerName: 'Departure\nTime', field: '', headerSx: { textAlign: 'left', width: "65px" }, },
    { headerName: 'Arrival\nTime', field: '', headerSx: { textAlign: 'left', width: "60px" }, },
    { headerName: 'Adult Fare/Adult Fare\n(Incl.Levies)', field: '', headerSx: { textAlign: 'right', minWidth: "160px", maxWidth: '160px' }, },
    { headerName: 'Child Fare/Child Fare(Incl.Levies)', field: '', headerSx: { textAlign: 'right', minWidth: "140px", maxWidth: '140px' }, },
    { headerName: 'Type', field: '', headerSx: { textAlign: 'left', width: "54px" }, },
    { headerName: 'Seats', field: '', headerSx: { textAlign: 'left', width: "51px" }, },
    { headerName: 'Trip Sheet\nCut-Off Time', field: '', headerSx: { textAlign: 'left', minWidth: "100px", maxWidth: '100px' }, },
    { headerName: 'Action', field: '', headerSx: { textAlign: 'left', width: "81px" }, },
]

export const passengerColumnDef = [
    { headerName: 'Seat No.', field: '', headerSx: { textAlign: 'left', width: "78px" }, },
    { headerName: 'Name', field: '', headerSx: { textAlign: 'left', width: "418px" }, },
    { headerName: 'Gender', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Age', field: '', headerSx: { textAlign: 'left', width: "100px" }, },
    { headerName: 'Concession', field: '', headerSx: { textAlign: 'left', width: "254px" }, },
    { headerName: 'Concession No', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Nationality', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Basic Fare', field: '', headerSx: { textAlign: 'right', width: "177px" }, },
]

export const passengerOthNationaColumnDef = [
    { headerName: 'Seat No.', field: '', headerSx: { textAlign: 'left', width: "70px" }, },
    { headerName: 'Name', field: '', headerSx: { textAlign: 'left', width: "120px" }, },
    { headerName: 'Gender', field: '', headerSx: { textAlign: 'left', width: "106px" }, },
    { headerName: 'Age', field: '', headerSx: { textAlign: 'left', width: "80px" }, },
    { headerName: 'Nationality', field: '', headerSx: { textAlign: 'left', width: "138px" }, },
    { headerName: 'Date Of Birth\nAs In Passport', field: '', headerSx: { textAlign: 'left', width: "160px" }, },
    { headerName: 'Passport or Travel\nDocument Number', field: '', headerSx: { textAlign: 'left', width: "150px" }, },
    { headerName: 'Address in India\n(Including Hotels)', field: '', headerSx: { textAlign: 'left', width: "150px" }, },
    { headerName: 'Basic Fare', field: '', headerSx: { textAlign: 'right', width: "98px" }, },
]
export const passengerAllNationaColumnDef = [
    { headerName: 'Seat No.', field: '', headerSx: { textAlign: 'left', width: "70px" }, },
    { headerName: 'Name', field: '', headerSx: { textAlign: 'left', width: "120px" }, },
    { headerName: 'Gender', field: '', headerSx: { textAlign: 'left', width: "106px" }, },
    { headerName: 'Age', field: '', headerSx: { textAlign: 'left', width: "80px" }, },
    { headerName: 'Concession', field: '', headerSx: { textAlign: 'left', width: "150px" }, },
    { headerName: 'Concession No', field: '', headerSx: { textAlign: 'left', width: "100px" }, },
    { headerName: 'Nationality', field: '', headerSx: { textAlign: 'left', width: "138px" }, },
    { headerName: 'Date Of Birth\nAs In Passport', field: '', headerSx: { textAlign: 'left', width: "150px" }, },
    { headerName: 'Passport or Travel\nDocument Number', field: '', headerSx: { textAlign: 'left', width: "150px" }, },
    { headerName: 'Address in India\n(Including Hotels)', field: '', headerSx: { textAlign: 'left', width: "150px" }, },
    { headerName: 'Basic Fare', field: '', headerSx: { textAlign: 'right', width: "98px" }, },
]
export const passengerSectionTotal = [
    { name: 'Reservation Fee (+)', field: 'reservation' },
    { name: 'Concessions (-)', field: 'concessions' },
    { name: 'ARF+UF+TF+EF+BF+INFRA (+)', field: 'levies' },
    { name: 'GST (+)', field: 'gst' },
    { name: 'Total Fare', field: 'totalFare' },
    { name: ' Amount to be Collected', field: 'totalFare' },
]
export const passengerSectionTotalWithRoundOff = [
    { name: 'Reservation Fee (+)', field: 'reservation' },
    { name: 'Concessions (-)', field: 'concessions' },
    { name: 'ARF+UF+TF+EF+BF+INFRA (+)', field: 'levies' },
    { name: 'GST (+)', field: 'gst' },
    { name: 'Total Fare', field: 'totalFare' },
    { name: 'RoundOff', field: 'roundOff' },
    { name: 'Amount to be Collected', field: 'balance' },
]

export const paymentModaList = [
    { id: 0, name: "Cash" },
    { id: 1, name: "Credit/Debit" },
    { id: 2, name: "Net Banking" },
    { id: 3, name: "UPI" },
]

export const genderList = [
    { id: 'M', name: 'Male' },
    { id: 'F', name: 'Female' },
    { id: 'O', name: 'Other' },
]

export const upiAppList = [
    { id: 0, name: "PAYTM UPI" },
    { id: 1, name: "GOOGLE PAY" },
    { id: 2, name: "PHONE PAY" },
]

export const bookingDetailsObj = {
    fullName: '',
    mobileNo: '',
    emailID: '',
    gstNo: '',
    selCountry: [],
    paymentModa: [paymentModaList[0]],
    passengeConcession: [],
    bank: [],
    UpiApp: [],
    refNumber: "",
    droppingPoint: [],
    boardingPoint: [],
    ticketNo: '',
    selectSeatList: [],
    totalFare: 0,
    passportDate: formatDate(window.getTime ? window.getTime() : new Date()),
    passWordNumber: '',
    addressIndia: '',
    disCount: 0,
    roundOff: 0,
    balance: 0
}

export function genderCount(obj) {
    return obj.reduce((acc, curVal) => {
        if (curVal.passengeGender?.[0]?.id === 'M') {
            acc.male++;
        }
        else {
            acc.female++;
        }
        return acc;
    }, { male: 0, female: 0 });
}
export function genderCountSelSeat(obj) {
    return obj.reduce((acc, curVal) => {
        if (curVal.passageGender?.[0]?.id === 'M') {
            acc.male++;
        }
        else {
            acc.female++;
        }
        return acc;
    }, { male: 0, female: 0 });
}


export const onwardBookingData = {
    fullName: '',
    mobileNo: '',
    emailID: '',
    gstNo: '',
    paymentModa: [paymentModaList[0]],
    selCountry: [],
    passengeConcession: [],
    bank: [],
    UpiApp: [],
    refNumber: "",
    droppingPoint: [],
    boardingPoint: [],
    ticketNo: '',
    selectSeatList: [],
    totalFare: 0,
    FromCityID: 0,
    ToCityID: 0,
    JourneyDate: '',
    TripID: 0,
    SeaterLow: 0,
    SeaterHigh: 0,
    SlumberLow: 0,
    SlumberHigh: 0,
    SleeperLow: 0,
    SleeperHigh: 0,
    ChartDate: '',
    passportDate: formatDate(window.getTime ? window.getTime() : new Date()),
    passWordNumber: '',
    addressIndia: '',
    ServiceTypeID: '',
    ArrivalTimeActual: formatDate(window.getTime ? window.getTime() : new Date()),
    disCount: 0,
    roundOff: 0,
}


//Block Seat Booking

export const blockSeatBkgCol = [
    { headerName: 'Source', field: '', headerSx: { textAlign: 'left', width: "280px" }, },
    { headerName: 'Destination', field: '', headerSx: { textAlign: 'left', width: "280px" }, },
    { headerName: 'Blocking Type', field: '', headerSx: { textAlign: 'left', width: "200px" }, },
    { headerName: 'Seat No(s)', field: '', headerSx: { textAlign: 'left', width: "100px" }, },
    { headerName: 'Reference Number', field: '', headerSx: { textAlign: 'left', width: "140px" }, },
    { headerName: 'Action', field: '', headerSx: { textAlign: 'left', width: "120px" }, },
]

export const ConcessionOpt = [
    { ConcessionTypeID: 17, ConcessionTypeName: 'GENERAL PUBLIC' }
]
export const selectConcPerTicket = (seatArray = [], seatpostion, concessionOpt = [], selConcession = [], ConcessionTypeID) => {
    let selectconcession = [...selConcession]
    let concession = concessionOpt?.filter((obj) => obj?.ConcessionTypeID === ConcessionTypeID)
    if ([35, 4]?.includes(Number(ConcessionTypeID))) {
        let newSeatArray = seatArray.map((value, index) => {
            let gender = (concession?.[0]?.Gender === value?.passageGender?.[0]?.id || concession?.[0]?.Gender === '') || (concession?.[0]?.Gender === 'O' && value?.passageGender?.[0]?.id === 'M')
            if (concession.length > 0 && (concession?.[0]?.MaxPersonPerTicket > selectconcession.filter((item) => item?.SeatLabel !== value?.SeatLabel && item?.ConcessionID === concession?.[0]?.ConcessionTypeID).length) && (value?.passageGender.length > 0 && value?.psgAge.trim() !== '') && (value?.psgAge !== '' ? value?.psgAge > 11 ? true : index === seatpostion ? concession?.[0]?.IsChild === 1 : value?.psgConcession?.[0]?.IsChild === 1 : false) && ((index === seatpostion ? concession?.[0]?.ConcessionTypeID === 35 : (ConcessionTypeID === 35 ? (value.psgConcession.length === 0 || value?.psgConcession?.[0]?.ConcessionTypeID === 35) : value?.psgConcession?.[0]?.ConcessionTypeID === 35)) ? value?.psgAge > 59 : true) && gender) {
                if (value.psgConcession.length === 0 || !([35, 4]?.includes(Number(value?.psgConcession?.[0]?.ConcessionTypeID)))) {
                    if ((35 === ConcessionTypeID && value?.psgAge < 60)) {
                        selectconcession[index] = {}
                        return { ...value, psgConcession: [], refNumber: '' }
                    } else {
                        selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                        return { ...value, psgConcession: concession, refNumber: '' }
                    }
                } else if (([35, 4]?.includes(Number(value?.psgConcession?.[0]?.ConcessionTypeID))) && value.psgConcession.length > 0 && (value?.psgConcession?.[0]?.ConcessionTypeID !== ConcessionTypeID)) {
                    if ((35 === ConcessionTypeID && value?.psgAge > 59)) {
                        selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                        return { ...value, psgConcession: concession, refNumber: '' }
                    } else if (4 === ConcessionTypeID && seatpostion === index && value?.psgAge > 59) {
                        selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                        return { ...value, psgConcession: concession, refNumber: '' }

                    } else {
                        return value
                    }
                } else {
                    selectconcession[index] = { ConcessionID: value?.psgConcession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                    return value
                }
            } else {
                selectconcession[index] = {}
                return { ...value, psgConcession: [], refNumber: '' }
            }
        })
        return { newSeatArray, selectconcession }
    } else {
        let newSeatArray = seatArray.map((value, index) => {
            let gender = (concession?.[0]?.Gender === value?.passageGender?.[0]?.id || concession?.[0]?.Gender === '') || (concession?.[0]?.Gender === 'O' && value?.passageGender?.[0]?.id === 'M')
            if (concession.length > 0 && (concession?.[0]?.MaxPersonPerTicket > selectconcession.filter((item) => item?.SeatLabel !== value?.SeatLabel && item?.ConcessionID === concession?.[0]?.ConcessionTypeID).length) && (value?.passageGender.length > 0 && value?.psgAge.trim() !== '') && (value?.psgAge !== '' ? value?.psgAge > 11 ? true : concession?.[0]?.IsChild === 1 : false) && (concession?.[0]?.ConcessionTypeID === 35 ? value?.psgAge > 59 : true) && gender) {
                selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                return { ...value, psgConcession: concession, refNumber: '' }
            } else {
                selectconcession[index] = {}
                return { ...value, psgConcession: [], refNumber: '' }
            }
        })
        return { newSeatArray, selectconcession }

    }

}







export const selectConcBlockTicket = (seatArray = [], seatpostion, concessionOpt = [], selConcession = [], ConcessionTypeID) => {
    let selectconcession = [...selConcession]
    let concession = concessionOpt?.filter((obj) => obj?.ConcessionTypeID === ConcessionTypeID)
    if ([35, 4]?.includes(Number(ConcessionTypeID))) {
        let newSeatArray = seatArray.map((value, index) => {
            let gender = (concession?.[0]?.Gender === value?.Gender?.[0]?.id || concession?.[0]?.Gender === '') || (concession?.[0]?.Gender === 'O' && value?.Gender?.[0]?.id === 'M')
            if (concession.length > 0 && (concession?.[0]?.MaxPersonPerTicket > selectconcession.filter((item) => item?.SeatLabel !== value?.SeatLabel && item?.ConcessionID === concession?.[0]?.ConcessionTypeID).length) && (value?.Gender.length > 0 && value?.Age?.toString().trim() !== '') && (value?.Age !== '' ? value?.Age > 11 ? true : index === seatpostion ? concession?.[0]?.IsChild === 1 : value?.psgConcession?.[0]?.IsChild === 1 : false) && ((index === seatpostion ? concession?.[0]?.ConcessionTypeID === 35 : (ConcessionTypeID === 35 ? (value.psgConcession.length === 0 || value?.psgConcession?.[0]?.ConcessionTypeID === 35) : value?.psgConcession?.[0]?.ConcessionTypeID === 35)) ? value?.Age > 59 : true) && gender) {
                if (value.Concession.length === 0 || !([35, 4]?.includes(Number(value?.Concession?.[0]?.ConcessionTypeID)))) {
                    if ((35 === ConcessionTypeID && value?.Age < 60)) {
                        selectconcession[index] = {}
                        return { ...value, Concession: [], refNumber: '' }
                    } else {
                        selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                        return { ...value, Concession: concession, refNumber: '' }
                    }
                } else if (([35, 4]?.includes(Number(value?.Concession?.[0]?.ConcessionTypeID))) && value.Concession.length > 0 && (value?.psgConcession?.[0]?.ConcessionTypeID !== ConcessionTypeID)) {
                    if ((35 === ConcessionTypeID && value?.Age > 59)) {
                        selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                        return { ...value, Concession: concession, refNumber: '' }
                    } else if (4 === ConcessionTypeID && seatpostion === index && value?.Age > 59) {
                        selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                        return { ...value, Concession: concession, refNumber: '' }
                    } else {
                        return value
                    }
                } else {
                    return value
                }
            } else {
                selectconcession[index] = {}
                return { ...value, Concession: [], refNumber: '' }
            }
        })
        return { newSeatArray, selectconcession }
    } else {
        let newSeatArray = seatArray.map((value, index) => {
            let gender = (concession?.[0]?.Gender === value?.Gender?.[0]?.id || concession?.[0]?.Gender === '') || (concession?.[0]?.Gender === 'O' && value?.Gender?.[0]?.id === 'M')
            if (concession.length > 0 && (concession?.[0]?.MaxPersonPerTicket > selectconcession.filter((item) => item?.SeatLabel !== value?.SeatLabel && item?.ConcessionID === concession?.[0]?.ConcessionTypeID).length) && (value?.Gender.length > 0 && value?.Age?.toString().trim() !== '') && (value?.Age !== '' ? value?.Age > 11 ? true : concession?.[0]?.IsChild === 1 : false) && (concession?.[0]?.ConcessionTypeID === 35 ? value?.Age > 59 : true) && gender) {
                selectconcession[index] = { ConcessionID: concession?.[0]?.ConcessionTypeID, SeatLabel: value?.SeatLabel }
                return { ...value, Concession: concession, refNumber: '' }
            } else {
                selectconcession[index] = {}
                return { ...value, Concession: [], refNumber: '' }
            }
        })
        return { newSeatArray, selectconcession }

    }

}

export const checkAllSeatAge = (arr = []) => {
    let isAdult = false
    arr.forEach((val) => {
        if (val.passengerAge > 11) {
            isAdult = true
        }
    })
    return isAdult
}

export const checkBookingValue = (arr) => {
    let checkingValue = false
    let errorMsg = []
    arr.forEach((val) => {
        if (val?.psgConcession.length > 0) {
            if (val?.psgConcession?.[0]?.IsCardEntry === 1 && val?.refNumber?.trim() === '' && val?.psgNationality?.[0]?.CountryID === 1) {// value?.psgNationality?.[0]?.CountryID === 1here check contry should be india only
                errorMsg?.push(val?.psgConcession?.[0]?.ConcessionTypeName)
                checkingValue = true
            }
        }
    })
    return { checkingValue, errorMsg: `Please Enter Concession No for ${Array.from(new Set(errorMsg))?.join(',')}` }
}